const projects = [
  {
    slug: 'krysia-ct',
    title: 'Krysia Court',
    location: 'Annandale, Virginia',
    date: 'February – March 2026',
    description: [
      'A spirited home where Latin American art and globally sourced furnishings and decor share the conversation. Every room in this Northern Virginia residence tells a story — from the stone fireplace anchoring the family room to the sunroom\'s vaulted ceilings framing natural light.',
      'We layered cultural treasures with comfortable, livable pieces: Italian pottery on bamboo tables, vintage family portraits beside bold contemporary fabrics, and wicker furniture softened with botanical prints. The result is a home that feels both collected and cohesive.',
    ],
    pullQuotes: [
      'A home should feel like a journey — every corner revealing something personal, something beautiful.',
      'We wanted each room to honor the family\'s heritage while feeling completely of the moment.',
    ],
    heroImage: '/images/portfolio/krysia-ct/krysia-ct-living-room-wide.jpg',
    coverImage: '/images/portfolio/krysia-ct/krysia-ct-entry-gold-console.jpg',
    photos: [
      { src: '/images/portfolio/krysia-ct/krysia-ct-living-room-wide.jpg', alt: 'Living room with exposed beams, white sofa, and blue accent chairs' },
      { src: '/images/portfolio/krysia-ct/krysia-ct-family-room-full.jpg', alt: 'Family room with stone fireplace and blue chairs' },
      { src: '/images/portfolio/krysia-ct/krysia-ct-entry-gold-console.jpg', alt: 'Entry foyer with gold bamboo console and Latin art' },
      { src: '/images/portfolio/krysia-ct/krysia-ct-entry-console-wide.jpg', alt: 'Entry foyer wide view with symmetric lamps' },
      { src: '/images/portfolio/krysia-ct/krysia-ct-dining-room-magnolia.jpg', alt: 'Dining room with walnut table and magnolia centerpiece' },
      { src: '/images/portfolio/krysia-ct/krysia-ct-kitchen-island.jpg', alt: 'Kitchen with white cabinets and quartz island' },
      { src: '/images/portfolio/krysia-ct/krysia-ct-hallway-painting-bamboo-table.jpg', alt: 'Hallway with abstract painting and Italian pottery on bamboo table' },
      { src: '/images/portfolio/krysia-ct/krysia-ct-fireplace-corner.jpg', alt: 'Family room corner with dancer painting and stone fireplace' },
      { src: '/images/portfolio/krysia-ct/krysia-ct-formal-living-sectional.jpg', alt: 'Formal living room with striped sectional sofa' },
      { src: '/images/portfolio/krysia-ct/krysia-ct-living-room-sofa-detail.jpg', alt: 'Living room detail with paisley pillows and Argentina book' },
      { src: '/images/portfolio/krysia-ct/krysia-ct-portrait-vignette.jpg', alt: 'Portrait painting with blue patterned vase and branches' },
      { src: '/images/portfolio/krysia-ct/krysia-ct-side-table-lamp-art.jpg', alt: 'Side table vignette with vintage photos and party painting' },
      { src: '/images/portfolio/krysia-ct/krysia-ct-sunroom-full.jpg', alt: 'Sunroom with vaulted ceiling and wicker furniture' },
      { src: '/images/portfolio/krysia-ct/krysia-ct-sunroom-wicker-coffee-table.jpg', alt: 'Sunroom coffee table with ceramic sculptures' },
      { src: '/images/portfolio/krysia-ct/krysia-ct-vintage-photo-chinoiserie.jpg', alt: 'Vintage family photo with chinoiserie ginger jar' },
      { src: '/images/portfolio/krysia-ct/krysia-ct-vintage-portrait-vase.jpg', alt: 'Vintage portrait with hydrangeas in blue and white vase' },
    ],
  },
  {
    slug: 'oakton-crossing',
    title: 'Oakton Crossing Court',
    location: 'Oakton, Virginia',
    date: 'July – October 2025',
    description: [
      'Color and culture take center stage in this warm, art-filled home. A gallery wall of Latin American paintings — vivid mother-and-child scenes, hand-painted plates, and botanical prints — transforms the living room into a personal museum.',
      'We balanced the bold artwork with classic furnishings: needlepoint dining chairs, a drum chandelier over the formal table, and an olive green entry bench that welcomes you with character from the very first step inside.',
    ],
    pullQuotes: [
      'Art isn\'t decoration — it\'s the soul of a room. We let the collection lead the design.',
      'Every piece in this home was chosen because it means something to the family.',
    ],
    heroImage: '/images/portfolio/oakton-crossing/IMG_2283.jpeg',
    coverImage: '/images/portfolio/oakton-crossing/IMG_2266.jpeg',
    photos: [
      { src: '/images/portfolio/oakton-crossing/IMG_2283.jpeg', alt: 'Dining room with drum chandelier and formal table' },
      { src: '/images/portfolio/oakton-crossing/IMG_2266.jpeg', alt: 'Living room with colorful gallery wall and white sofa' },
      { src: '/images/portfolio/oakton-crossing/IMG_2268.jpeg', alt: 'Gallery wall close-up with armchair' },
      { src: '/images/portfolio/oakton-crossing/IMG_2271.jpeg', alt: 'Bay window nook with pedestal table and monstera' },
      { src: '/images/portfolio/oakton-crossing/IMG_2277.jpeg', alt: 'Dining room corner with decorative plates and portrait' },
      { src: '/images/portfolio/oakton-crossing/IMG_2285.jpeg', alt: 'Dining table with hydrangeas and wooden bead runner' },
      { src: '/images/portfolio/oakton-crossing/IMG_1819.jpeg', alt: 'Entry bench with floral cushion and wicker baskets' },
    ],
  },
  {
    slug: 'belle-haven',
    title: 'Windsor Rd',
    location: 'Alexandria, Virginia',
    date: 'August 2025',
    description: [
      'Classic Americana meets refined Southern charm in this Belle Haven residence. Sage green walls with crisp white wainscoting create a timeless backdrop for a curated collection of equestrian art and family heirlooms.',
      'From the stained glass front door to the plaid wingback chairs flanking the fireplace, every detail speaks to a life well-lived. An Hermès blanket draped casually over an arm, a piano room lined with generations of family photos — this is heritage, made comfortable.',
    ],
    pullQuotes: [
      'True elegance is a home that looks like it\'s been loved for generations.',
      'We designed around the family\'s story — the art, the heirlooms, the memories.',
    ],
    heroImage: '/images/portfolio/belle-haven/IMG_1587.jpeg',
    coverImage: '/images/portfolio/belle-haven/IMG_1594.jpeg',
    photos: [
      { src: '/images/portfolio/belle-haven/IMG_1587.jpeg', alt: 'Fireplace sitting room with plaid wingback chairs' },
      { src: '/images/portfolio/belle-haven/IMG_1590.jpeg', alt: 'Living room with leather sofa and fireplace' },
      { src: '/images/portfolio/belle-haven/IMG_1594.jpeg', alt: 'Entryway with antique console and stained glass door' },
      { src: '/images/portfolio/belle-haven/IMG_1530.jpeg', alt: 'Hallway with half-moon table and sage wainscoting' },
      { src: '/images/portfolio/belle-haven/IMG_1537.jpeg', alt: 'Piano room with family photos and sage green walls' },
    ],
  },
  {
    slug: 'unknown-project',
    title: 'Mount Vernon Circle',
    location: 'Alexandria, Virginia',
    date: 'November – December 2025',
    description: [
      'Calm, considered, and effortlessly sophisticated. This home embraces a palette of warm creams, soft sage, and natural textures — chunky knit throws, hammered metal mirrors, and light wood furniture that catches the morning sun.',
      'Each bedroom was designed as a sanctuary. Designer books stacked on nightstands, amethyst accents catching the light, and sailboat paintings that bring a sense of coastal tranquility to Virginia.',
    ],
    pullQuotes: [
      'A bedroom should be the quietest sentence in the house — soft, intentional, and deeply personal.',
      'Luxury isn\'t about labels. It\'s about how a room makes you feel the moment you walk in.',
    ],
    heroImage: '/images/portfolio/unknown-project/IMG_2818.jpeg',
    coverImage: '/images/portfolio/unknown-project/IMG_2787.jpeg',
    photos: [
      { src: '/images/portfolio/unknown-project/IMG_2818.jpeg', alt: 'Master bedroom with drum chandelier and wing headboard' },
      { src: '/images/portfolio/unknown-project/IMG_2809.jpeg', alt: 'Primary bedroom with cream dresser and hammered mirror' },
      { src: '/images/portfolio/unknown-project/IMG_2787.jpeg', alt: 'Master bed with wing headboard and rope knit throw' },
      { src: '/images/portfolio/unknown-project/IMG_2782.jpeg', alt: 'Nightstand with designer books and marble lamp' },
      { src: '/images/portfolio/unknown-project/IMG_2784.jpeg', alt: 'Dresser vignette with hammered mirror and orchids' },
      { src: '/images/portfolio/unknown-project/IMG_2811.jpeg', alt: 'Dresser detail with hammered mirror close-up' },
      { src: '/images/portfolio/unknown-project/IMG_2794.jpeg', alt: 'Guest bedroom with sailboat painting and sage throw' },
      { src: '/images/portfolio/unknown-project/IMG_2795.jpeg', alt: 'Guest bedroom side angle with gold mirror' },
      { src: '/images/portfolio/unknown-project/IMG_2807.jpeg', alt: 'Guest bedroom wide with green throw and orchid' },
      { src: '/images/portfolio/unknown-project/IMG_2803.jpeg', alt: 'Sitting nook with cream armchair and chunky throw' },
      { src: '/images/portfolio/unknown-project/IMG_2816.jpeg', alt: 'Master bedroom dresser side with gold mirror' },
    ],
  },
];

export default projects;
